import angular from 'angular'

import accountCtrl from './account.controller'
import accountRoutes from './account.routes'
import accountRun from './account.run'
import accountMenu from './account.menu'

const name = 'routingAccount'

angular.module(name, [])
  .controller('accountCtrl', accountCtrl)
  .config(accountRoutes)
  .run(accountRun)
  .factory('accountMenu', accountMenu)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/account.module.js